import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ResourceList from "../../../../components/resourceList/ResourceList";
import Input from "../../../../components/input/Input";
import { fetchPendingVendingControllers } from "../../../../store/actions/admin/vendingControllers";
import styles from "./PendingVendingControllers.module.scss";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import classNames from "classnames";

const HEADER_VALUES = [
  { label: "MAC ADRESA", key: "macAddress", sortable: true },
  { label: "SERIJSKI BROJ", key: "serialNumber", sortable: true },
  { label: "POREKLO", key: "recycledFromVendingControllerId", sortable: false },
  { label: "AKCIJE", sortable: false },
];

const PendingVendingControllers = () => {
  const dispatch = useDispatch();
  const pendingVendingControllers = useSelector(
    (state) => state.vendingControllers.pendingVendingControllers
  );
  const history = useHistory();

  const { page, perPage, total, data, attempt } = pendingVendingControllers || {};
  const [searchTerm, setSearchTerm] = useState("");
  const searchVendingControllers = _.debounce((searchTerm) => {
    dispatch(fetchPendingVendingControllers(1, perPage || 15, searchTerm));
  }, 600);

  useEffect(() => {
    dispatch(fetchPendingVendingControllers(1, 15, ""));
  }, [dispatch]);

  useEffect(() => {
    searchVendingControllers(searchTerm);
  }, [searchTerm]);

  const onLoadPage = (newPage) => {
    dispatch(fetchPendingVendingControllers(newPage, perPage || 15, searchTerm));
  };

  const onSort = (sortBy, order) => {
    // Sorting can be implemented if needed
    dispatch(fetchPendingVendingControllers(1, perPage || 15, searchTerm));
  };

  const renderVendingControllerRow = (controller, index) => {
    return (
      <div
        className={classNames(styles.row, index % 2 === 0 ? styles.even : styles.odd)}
        key={controller.id}
        onClick={() => history.push(`/vending-controllers/${controller.id}`)}
      >
        <div className={styles.cell}>
          <a
            href={`https://sdf.rs/vending-controllers/${controller.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.aTag}
            onClick={(e) => e.stopPropagation()}
          >
            <p>{controller.macAddress || "-"}</p>
          </a>
        </div>
        <div className={styles.cell}>
          <p>{controller.serialNumber || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>
            {controller.recycledFromVendingControllerId
              ? `Oslobođen iz #${controller.recycledFromVendingControllerId}`
              : "-"}
          </p>
        </div>
        <div className={styles.cell}>
          <button
            className={styles.viewButton}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/vending-controllers/${controller.id}`);
            }}
          >
            Pregled
          </button>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.content}>
      <div className={styles.topPart}>
        <p className={styles.title}>Pending</p>
        <div className={styles.flexEnd}>
          <div className={styles.inputWrapper}>
            <Input
              onChange={(value) => {
                setSearchTerm(value);
              }}
              value={searchTerm}
              placeholder={searchTerm === "" && "Search"}
            />
          </div>
        </div>
      </div>
      <div className={styles.listWrapper}>
        <ResourceList
          resource={{
            data: data || [],
            total: total || 0,
            page: page || 1,
            perPage: perPage || 15,
            attempt: attempt || false,
          }}
          headerValues={HEADER_VALUES}
          onLoadPage={onLoadPage}
          onSort={onSort}
          rowRender={renderVendingControllerRow}
          showLoader={true}
        />
      </div>
    </div>
  );
};

export default PendingVendingControllers;
